import React from 'react';
export const NCContext = React.createContext({});
NCContext.displayName = 'NCContext';

//# sourceMappingURL=NCContext.js.map